import { createContext } from 'react';

export const LayoutContext = createContext({
  title: null,
  titleSecondPart: null,
  numberOfMentions: null,
});
